import './SearchResults.css';
import React from 'react';
import SearchResultsList from './SearchResultsList';
var SearchResults = function SearchResults(_ref) {
  var sitecoreContext = _ref.sitecoreContext,
    analytics = _ref.analytics,
    params = _ref.params,
    defaultTypeValues = _ref.defaultTypeValues,
    lbNoResults = _ref.lbNoResults,
    activeListingItemId = _ref.activeListingItemId,
    lbResultsFor = _ref.lbResultsFor,
    getActivePopupOnMap = _ref.getActivePopupOnMap,
    activeTopPicks = _ref.activeTopPicks,
    toggleActiveTopPicks = _ref.toggleActiveTopPicks,
    hits = _ref.hits,
    query = _ref.query,
    mainHitsPerPage = _ref.mainHitsPerPage;
  var hasResults = query && hits.length !== 0;
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  return /*#__PURE__*/React.createElement("div", {
    className: "search-results ".concat(query ? 'visible' : ' ', " imfilters-padding ").concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles)
  }, query && /*#__PURE__*/React.createElement(React.Fragment, null, hits && hits.length ? /*#__PURE__*/React.createElement("div", {
    className: "results-amount"
  }, /*#__PURE__*/React.createElement("b", null, "".concat(hits.length, " ")), lbResultsFor.value, /*#__PURE__*/React.createElement("b", null, " \"".concat(query, "\""))) : /*#__PURE__*/React.createElement("div", {
    className: "results-amount"
  }, lbNoResults.value)), query && hasResults && /*#__PURE__*/React.createElement(SearchResultsList, {
    params: params,
    rtl: rtl,
    defaultTypeValues: defaultTypeValues,
    activeListingItemId: activeListingItemId,
    getActivePopupOnMap: getActivePopupOnMap,
    activeTopPicks: activeTopPicks,
    toggleActiveTopPicks: toggleActiveTopPicks,
    hits: hits,
    mainHitsPerPage: mainHitsPerPage,
    query: query,
    analytics: analytics
  }));
};
export default SearchResults;
var commonStyles = "c1u2pec0";
var ltrStyles = "l1s6emgl";
var rtlStyles = "rchgxkq";